const PresenceDot = ({ online, size = 10, className = "" }) => {
  if (!online) return null;
  return (
    <span
      className={`presence-dot ${className}`}
      style={{ width: size, height: size }}
      title="Online"
      aria-label="Online"
    />
  );
};

export default PresenceDot;
